import Config from '@/config';
import { SupplyRequestListResult } from '@/types/api/supplyRequest';
import http, { HttpPromise } from './http';

const list = (role: string, params?: SupplyRequestListResult): HttpPromise<SupplyRequestListResult> => http.get<SupplyRequestListResult>(`${Config.apiHost}/${role}/supplyRequest/list/`, { params });
const details = (role: string, params?: SupplyRequestListResult): HttpPromise<SupplyRequestListResult> => http.post(`${Config.apiHost}/${role}/supplyRequest/detail/`, params);

export default {
  supplySave: async (params) => http.post(`${Config.apiHost}/contractor/supplyRequest/save/`, params),
  objectsList: async () => http.post(`${Config.apiHost}/contractor/supplyRequest/objects/`),
  nomenclatures: async (params) => http.post(`${Config.apiHost}/contractor/supplyRequest/nomenclatures/`, params),
  vendorSelection: async (params) => http.post(`${Config.apiHost}/customer/supplyRequest/status/changeStatusOnVendorSelection/`, params),
  cancel: async (params) => http.post(`${Config.apiHost}/customer/supplyRequest/status/changeStatusOnCancel/`, params),
  getMaterialsGuideFile: async () => http.get(`${Config.apiHost}/supplier/materialsGuideFile/`),
  contractor: {
    list: list.bind(this, 'contractor'),
    details: details.bind(this, 'contractor'),
  },
  customer: {
    list: list.bind(this, 'customer'),
    details: details.bind(this, 'customer'),
  },
  administrator: {
    list: list.bind(this, 'customer'),
    details: details.bind(this, 'customer'),
  },
};
